import { Injectable } from '@angular/core'
import { environment } from '@envs/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { DashboardDataFilter } from '@app/features/dashboards/components/finance/finance.component'

@Injectable({ providedIn: 'root' })
export class DashboardService {
  private readonly BASE_API_URL: string = environment.scopeApiUrl

  constructor(private http: HttpClient) {}

  getFinanceReportData(filters: DashboardDataFilter): Observable<any> {
    return this.http.post<any>(`${this.BASE_API_URL}dashboard/finance-report/data-request`, filters)
  }

  getFiltersData(filters: any): Observable<any> {
    return this.http.get<any>(`${this.BASE_API_URL}dashboard/filter-options`, { params: { filterOptions: filters } })
  }
}
